import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Form, reduxForm } from 'redux-form';
import { Input } from 'angieslist-react-components';
import { map, extend, keys, pickBy, difference, get } from 'lodash';
import { goToError } from '../../../profile/browser/components/utils/Utils';

import './About.scss';

type State = {
  activeHighlights: Object,
};

type Props = {
  businessHighlights: any,
  handleSubmit: any,
  allBusinessHighlights: any,
  updateBusinessHighlights: any,
  setRef: Function,
};

class BusinessHighlightCheckboxes extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeHighlights: {},
    };
  }

  state: State;

  componentDidMount() {
    const { businessHighlights, allBusinessHighlights, setRef } = this.props;
    const highlightDifferential = difference(businessHighlights, allBusinessHighlights);
    highlightDifferential.forEach((entry) => {
      this.setState({
        activeHighlights:
         extend(this.state.activeHighlights, { [entry.name]: true }),
      });
    });

    if (setRef) {
      setRef(this);
    }
  }

  props: Props;

  excludeBusinessHighlights: ((allHighlights: Array) => Array) = (allHighlights: Array) => {
    const highlightsExcluded = ['MaskWearing', 'EcoFriendly', '247ServiceOffered', 'EmergencyServices'];
    return allHighlights.filter(highlight => !highlightsExcluded.includes(highlight.name));
  }

  submitHighlightChange = () => {
    const highlightsToSubmit = keys(pickBy(this.state.activeHighlights));
    this.props.updateBusinessHighlights(highlightsToSubmit);
  };

  handleCheckbox = (event) => {
    const highlightSelected = event.target.getAttribute('data-name');
    const highlightChecked = event.target.checked;
    this.setState({
      activeHighlights:
       extend(this.state.activeHighlights, { [highlightSelected]: highlightChecked }),
    });
  };

  render() {
    const {
      handleSubmit,
      allBusinessHighlights,
    } = this.props;
    return (
      <div id="Business-Highlights-Form--Container" className="mg-b-1em">
        <Form
          onSubmit={
            handleSubmit(() => this.submitHighlightChange(), goToError())
          }
          name="BusinessHighlights"
          id="Business-Highlights-Form"
        >
          {
            map(this.excludeBusinessHighlights(allBusinessHighlights), highlight => (
              <div
                id="Business-Highlights-Checkbox"
                className="mg-l-10"
                key={`key-${highlight.name}`}
              >
                <Input
                  id={`BusinessHighlightsCheckbox-${highlight.name}`}
                  name={`BusinessHighlightsCheckbox-${highlight.name}`}
                  type="checkbox"
                  label={highlight.description}
                  onClick={event => this.handleCheckbox(event)}
                  data-name={highlight.name}
                  defaultChecked={get(this.state.activeHighlights, `${highlight.name}`)}
                />
              </div>
            ))
          }
        </Form>
      </div>
    );
  }
}

export default hot(module)(compose(
  reduxForm({
    form: 'BusinessHighlights',
  }),
  connect(state => ({
    formState: state.form.BusinessHighlights,
  })),
  pure,
)(BusinessHighlightCheckboxes));



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/BusinessHighlightCheckboxes.js